import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import H1 from '@/components/base/Headings/H1';
import Icon from '@/components/base/Icon';
import { GiveawayResult } from '@/components/pages/giveaway-picker/Types/drawTypes';
import { DownloadImageBlock } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/Results/components/DownloadImageBlock';
import { Winner } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/Results/components/Winner';

export const RightBlock = ({ result }: { result: GiveawayResult }) => {
    const { t } = useTranslation('giveaway_picker');

    const extraWinners = result.result?.extra_winners
        ? Object.values(result.result.extra_winners)
        : [];

    return (
        <div className="w-full px-10 py-20 md:w-4/6 md:px-12 xl:px-36" data-testid="right-block">
            <H1 className="mb-14 !text-4xl sm:!text-5xl">{t('results.title')}</H1>
            <p className="mb-8 font-GMedium text-icoGray-500">{t('results.description')}</p>
            <div className="mb-10 grid grid-cols-6 gap-4" data-testid="winners-block">
                {result.result?.winners?.map((winner, index) => (
                    <Winner
                        key={winner.id}
                        winner={winner}
                        index={index}
                        totalWinners={result.result?.winners?.length ?? 0}
                    />
                ))}
            </div>
            {extraWinners.length > 0 ? (
                <div className="mb-14">
                    <Disclosure>
                        {({ open }) => (
                            <div className="rounded-md border border-icoGray-300 p-5 focus:outline-none">
                                <DisclosureButton
                                    className="focus flex w-full justify-between justify-items-center text-left font-GMedium text-icoBlack focus:outline-none focus:ring-0"
                                    data-testid="extra-winners-button">
                                    <span>{t('results.extra_winners_title')}</span>
                                    <Icon
                                        icon="chevron-bottom"
                                        className={clsx(
                                            'w-4 text-icoGray-400 transition-transform duration-200',
                                            open && 'rotate-180'
                                        )}
                                    />
                                </DisclosureButton>
                                <DisclosurePanel className="mt-6 text-sm text-icoBlack">
                                    <div
                                        className="col-span-6 flex flex-col gap-4 rounded-lg"
                                        data-testid="extra-winners-block">
                                        {extraWinners.map((winner, index) => (
                                            <Winner
                                                key={winner.id}
                                                winner={winner}
                                                index={index}
                                                totalWinners={extraWinners.length}
                                                isExtraWinner={true}
                                            />
                                        ))}
                                    </div>
                                </DisclosurePanel>
                            </div>
                        )}
                    </Disclosure>
                </div>
            ) : null}

            <DownloadImageBlock result={result} />
        </div>
    );
};
